import React from 'react';
import { Phone, MapPin, Clock, Instagram, Facebook, MessageCircle } from 'lucide-react';

const Footer = () => {
  const scrollToSimulator = () => {
    const el = document.querySelector('#simulador');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="contato" className="bg-[#0a0a0a] border-t border-white/10">
      {/* CTA */}
      <div className="py-16 md:py-20">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <span className="font-body text-xs tracking-[0.3em] uppercase text-[#C9A961]">Pronto para começar?</span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-white mt-3 mb-6">
            Faça seu orçamento agora
          </h2>
          <p className="font-body text-sm text-white/50 max-w-lg mx-auto mb-8">
            Monte seu evento no nosso simulador e receba um orçamento personalizado em segundos
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={scrollToSimulator}
              className="flex items-center justify-center gap-2 bg-gradient-to-r from-[#8B6F47] to-[#C9A961] text-white font-body font-semibold text-sm tracking-[0.15em] uppercase px-10 py-4 rounded-sm hover:shadow-lg hover:shadow-[#8B6F47]/30 transition-all"
            >
              Montar meu evento
            </button>
            <a
              href="https://wa.me/5531999172997"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 border border-white/30 text-white font-body text-sm tracking-[0.15em] uppercase px-10 py-4 rounded-sm hover:bg-white/5 transition-colors"
            >
              <MessageCircle className="w-4 h-4" />
              WhatsApp
            </a>
          </div>
        </div>
      </div>

      {/* Footer Info */}
      <div className="border-t border-white/5 py-12">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            <div>
              <h3 className="font-display text-xl text-white mb-4">
                Buffet{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#8B6F47] to-[#C9A961]">
                  MultiEventos
                </span>
              </h3>
              <p className="font-body text-sm text-white/40 leading-relaxed">
                Transformando eventos em experiências gastronômicas inesquecíveis há mais de 30 anos.
              </p>
            </div>

            <div>
              <h4 className="font-body text-xs tracking-[0.2em] uppercase text-white/60 mb-4">Contato</h4>
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <Phone className="w-4 h-4 text-[#C9A961]" />
                  <span className="font-body text-sm text-white/50">(31) 99917-2997</span>
                </div>
                <div className="flex items-center gap-3">
                  <MapPin className="w-4 h-4 text-[#C9A961]" />
                  <span className="font-body text-sm text-white/50">Belo Horizonte e Região</span>
                </div>
                <div className="flex items-center gap-3">
                  <Clock className="w-4 h-4 text-[#C9A961]" />
                  <span className="font-body text-sm text-white/50">Seg - Sáb: 9h às 18h</span>
                </div>
              </div>
            </div>

            <div>
              <h4 className="font-body text-xs tracking-[0.2em] uppercase text-white/60 mb-4">Redes sociais</h4>
              <div className="flex gap-4">
                <a
                  href="#"
                  className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-white/40 hover:border-[#8B6F47]/50 hover:text-[#C9A961] transition-all"
                >
                  <Instagram className="w-4 h-4" />
                </a>
                <a
                  href="#"
                  className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-white/40 hover:border-[#8B6F47]/50 hover:text-[#C9A961] transition-all"
                >
                  <Facebook className="w-4 h-4" />
                </a>
                <a
                  href="https://wa.me/5531999172997"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-white/40 hover:border-[#8B6F47]/50 hover:text-[#C9A961] transition-all"
                >
                  <MessageCircle className="w-4 h-4" />
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-white/5 mt-10 pt-8 text-center">
            <p className="font-body text-xs text-white/30">
              © 2025 Buffet MultiEventos. Todos os direitos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
